import { Tag } from 'antd'
import {
  MESSAGE_STATUS_MAP,
  DRAFT_STATUS_MAP,
  PLATFORM_STATUS_MAP,
  SLA_EVENT_STATUS_MAP,
} from '@/types/common'

type TagType = 'message' | 'draft' | 'platform' | 'sla'

const MAPS: Record<TagType, Record<string, string>> = {
  message: MESSAGE_STATUS_MAP,
  draft: DRAFT_STATUS_MAP,
  platform: PLATFORM_STATUS_MAP,
  sla: SLA_EVENT_STATUS_MAP,
}

const COLOR_MAP: Record<string, string> = {
  pending_response: 'orange',
  responded: 'green',
  drafted: 'blue',
  closed_no_ticket: 'default',
  binding_required: 'red',
  need_more_info: 'orange',
  confirmed: 'blue',
  created_task: 'green',
  rejected: 'default',
  waiting_start: 'orange',
  doing: 'processing',
  waiting_customer_confirm: 'purple',
  returned: 'red',
  closed: 'default',
  open: 'red',
  reminded: 'orange',
  ignored: 'default',
  resolved: 'green',
  normalized: 'default',
}

interface Props {
  type: TagType
  status: string
}

export default function StatusTag({ type, status }: Props) {
  const label = MAPS[type]?.[status] || status
  const color = COLOR_MAP[status] || 'default'
  return <Tag color={color}>{label}</Tag>
}
